import * as yup from 'yup';

const password = yup
  .string()
  .min(6, 'The string must be six characters or longer')
  .matches(/^\S*$/, 'The string must not contain whitespaces')
  // .matches(
  //   /(?=.*[a-z])/,
  //   'The string must contain at least 1 lowercase alphabetical character'
  // )
  // .matches(
  //   /(?=.*[A-Z])/,
  //   'The string must contain at least 1 uppercase alphabetical character'
  // )
  // .matches(
  //   /(?=.*[0-9])/,
  //   'The string must contain at least 1 numeric character'
  // )
  .required('Password is required!');

export default {
  password,
};



// WEBPACK FOOTER //
// ./src/utils/validations.js